import React from 'react';
import { Star, MessageCircle, Play, Mic, ChevronRight } from 'lucide-react';
export const CelebrityAI = () => {
  return <section className="space-y-4" data-id="element-2561">
      <div className="flex items-center justify-between" data-id="element-2562">
        <div className="flex items-center gap-2" data-id="element-2563">
          <Star size={18} className="text-yellow-400" data-id="element-2564" />
          <h2 className="text-lg font-bold" data-id="element-2565">Celebrity AI</h2>
        </div>
        <button className="text-sm text-pink-400" data-id="element-2566">View All</button>
      </div>
      <div className="overflow-x-auto pb-2 -mx-4 px-4" data-id="element-2567">
        <div className="flex gap-4" style={{
        minWidth: 'max-content'
      }} data-id="element-2568">
          {/* Celebrity Card 1 */}
          <div className="w-64 bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl border border-gray-700 overflow-hidden" data-id="element-2569">
            <div className="relative" data-id="element-2570">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png" alt="Bonny Blue" className="w-full h-48 object-cover" data-id="element-2571" />
              <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-2572">
                <Star size={12} className="text-yellow-400" data-id="element-2573" />
                <span className="text-xs" data-id="element-2574">Verified</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3" data-id="element-2575">
                <h3 className="font-bold text-white" data-id="element-2576">Bonny Blue</h3>
                <p className="text-xs text-gray-300" data-id="element-2577">Dominant & playful</p>
              </div>
            </div>
            <div className="p-3 space-y-3" data-id="element-2578">
              <div className="flex items-center justify-between" data-id="element-2579">
                <div className="flex items-center gap-1" data-id="element-2580">
                  <MessageCircle size={14} className="text-pink-400" data-id="element-2581" />
                  <span className="text-xs" data-id="element-2582">First message free</span>
                </div>
                <div className="text-xs px-2 py-0.5 bg-pink-500/20 rounded-full text-pink-400" data-id="element-2583">
                  Online
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2" data-id="element-2584">
                <button className="flex items-center justify-center gap-1 py-2 bg-pink-600 rounded-lg text-white text-sm" data-id="element-2585">
                  <MessageCircle size={14} data-id="element-2586" />
                  <span data-id="element-2587">Chat</span>
                </button>
                <button className="flex items-center justify-center gap-1 py-2 bg-gray-800 rounded-lg text-white text-sm" data-id="element-2588">
                  <Mic size={14} data-id="element-2589" />
                  <span data-id="element-2590">Voice</span>
                </button>
              </div>
              <button className="w-full flex items-center justify-between py-2 px-3 bg-gray-800 rounded-lg text-sm" data-id="element-2591">
                <div className="flex items-center gap-2" data-id="element-2592">
                  <Play size={14} className="text-pink-400" data-id="element-2593" />
                  <span data-id="element-2594">Unlock Striptease</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-2595">
                  <span data-id="element-2596">50</span>
                  <span className="text-pink-400" data-id="element-2597">💎</span>
                </div>
              </button>
            </div>
          </div>
          {/* Celebrity Card 2 */}
          <div className="w-64 bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl border border-gray-700 overflow-hidden" data-id="element-2598">
            <div className="relative" data-id="element-2599">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png" alt="Kim Holland" className="w-full h-48 object-cover" data-id="element-2600" />
              <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-2601">
                <Star size={12} className="text-yellow-400" fill="currentColor" data-id="element-2602" />
                <span className="text-xs" data-id="element-2603">Star</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3" data-id="element-2604">
                <h3 className="font-bold text-white" data-id="element-2605">Kim Holland</h3>
                <p className="text-xs text-gray-300" data-id="element-2606">Girl-next-door vibe</p>
              </div>
            </div>
            <div className="p-3 space-y-3" data-id="element-2607">
              <div className="flex items-center justify-between" data-id="element-2608">
                <div className="flex items-center gap-1" data-id="element-2609">
                  <Mic size={14} className="text-pink-400" data-id="element-2610" />
                  <span className="text-xs" data-id="element-2611">Real voice model</span>
                </div>
                <div className="text-xs px-2 py-0.5 bg-gray-700 rounded-full text-gray-400" data-id="element-2612">
                  Away
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2" data-id="element-2613">
                <button className="flex items-center justify-center gap-1 py-2 bg-pink-600 rounded-lg text-white text-sm" data-id="element-2614">
                  <MessageCircle size={14} data-id="element-2615" />
                  <span data-id="element-2616">Chat</span>
                </button>
                <button className="flex items-center justify-center gap-1 py-2 bg-gray-800 rounded-lg text-white text-sm" data-id="element-2617">
                  <Mic size={14} data-id="element-2618" />
                  <span data-id="element-2619">Voice</span>
                </button>
              </div>
              <button className="w-full flex items-center justify-between py-2 px-3 bg-gray-800 rounded-lg text-sm" data-id="element-2620">
                <div className="flex items-center gap-2" data-id="element-2621">
                  <Play size={14} className="text-pink-400" data-id="element-2622" />
                  <span data-id="element-2623">Unlock Private Show</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-2624">
                  <span data-id="element-2625">75</span>
                  <span className="text-pink-400" data-id="element-2626">💎</span>
                </div>
              </button>
            </div>
          </div>
          {/* Celebrity Card 3 */}
          <div className="w-64 bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl border border-gray-700 overflow-hidden" data-id="element-2627">
            <div className="relative" data-id="element-2628">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wd5J5ve8saMKYCJCDuBt1X/h1.png" alt="Emma Rose" className="w-full h-48 object-cover" data-id="element-2629" />
              <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-2630">
                <Star size={12} className="text-yellow-400" data-id="element-2631" />
                <span className="text-xs" data-id="element-2632">Verified</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3" data-id="element-2633">
                <h3 className="font-bold text-white" data-id="element-2634">Emma Rose</h3>
                <p className="text-xs text-gray-300" data-id="element-2635">Artistic & creative</p>
              </div>
            </div>
            <div className="p-3 space-y-3" data-id="element-2636">
              <div className="flex items-center justify-between" data-id="element-2637">
                <div className="flex items-center gap-1" data-id="element-2638">
                  <MessageCircle size={14} className="text-pink-400" data-id="element-2639" />
                  <span className="text-xs" data-id="element-2640">First message free</span>
                </div>
                <div className="text-xs px-2 py-0.5 bg-pink-500/20 rounded-full text-pink-400" data-id="element-2641">
                  Online
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2" data-id="element-2642">
                <button className="flex items-center justify-center gap-1 py-2 bg-pink-600 rounded-lg text-white text-sm" data-id="element-2643">
                  <MessageCircle size={14} data-id="element-2644" />
                  <span data-id="element-2645">Chat</span>
                </button>
                <button className="flex items-center justify-center gap-1 py-2 bg-gray-800 rounded-lg text-white text-sm" data-id="element-2646">
                  <Mic size={14} data-id="element-2647" />
                  <span data-id="element-2648">Voice</span>
                </button>
              </div>
              <button className="w-full flex items-center justify-between py-2 px-3 bg-gray-800 rounded-lg text-sm" data-id="element-2649">
                <div className="flex items-center gap-2" data-id="element-2650">
                  <Play size={14} className="text-pink-400" data-id="element-2651" />
                  <span data-id="element-2652">Unlock Private Show</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-2653">
                  <span data-id="element-2654">60</span>
                  <span className="text-pink-400" data-id="element-2655">💎</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};